<h2 mat-dialog-title class="bgDialogHeader text-center">View Details : {{data.woNumber}}
  <div class="pull-right">
    <a class="boxclose" (click)="closeDialog()"></a>
  </div>
</h2>
<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px'}"></ngx-loading>
<mat-dialog-content>
  <div class="row m-1" *ngIf="woDowntime && woRoViewDetails">
    <div class="col-sm-8">
      <table class="table col-12">
        <tbody>
          <tr>
            <td>
              <strong>Unit requiring Service:</strong>
            </td>
            <td>
              <label>{{woRoViewDetails.TSQlUnitBeingServiced == 1237 ? 'Truck' : woRoViewDetails.TSQlUnitBeingServiced == 1238 ? 'Trailer' : 'Other'}}</label>
            </td>
            <td>
              <strong>Estimated Cost:</strong>
            </td>
            <td>
              <label>{{woDowntime.wOTotalCost | currency}}</label>
            </td>
          </tr>
          <tr>
            <td>
              <strong>Truck #:</strong>
            </td>
            <td>
              <label>{{woRoViewDetails.TSQvc255VehicleNumber}}</label>
            </td>
            <td>
              <strong>Trailer #:</strong>
            </td>
            <td>
              <label>{{woRoViewDetails.TSQvc255TrailerNumber}}</label>
            </td>
          </tr>
          <tr>
            <td>
              <strong>Customer PO#:</strong>
            </td>
            <td>
              <label>{{woRoViewDetails.TSQvc255PONumber}}</label>
            </td>
            <td>
              <strong>Reference #:</strong>
            </td>
            <td>
              <label>{{woRoViewDetails.TSQvc255ReferenceNumber}}</label>
            </td>
          </tr>
          <tr>
            <td>
              <strong>Driver Name:</strong>
            </td>
            <td>
              <label>{{woRoViewDetails.TSQvc255DriverName}}</label>
            </td>
            <td>
              <strong>Driver Number:</strong>
            </td>
            <td>
              <label>{{woRoViewDetails.TSQvc255DriverPhone}}</label>
            </td>
          </tr>
          <tr>
            <td>
              <strong>Call Placer Name:</strong>
            </td>
            <td>
              <label>{{woRoViewDetails.CallerName}}</label>
            </td>
            <td>
              <strong>Call Placer Phone Number:</strong>
            </td>
            <td>
              <label>{{woRoViewDetails.CallerPhone}}</label>
            </td>
          </tr>
          <tr>
            <td>
              <strong>Customer:</strong>
            </td>
            <td>
              <label>{{customerName}}</label>
            </td>
            <td>
              <strong>Region:</strong>
            </td>
            <td>
              <label>{{subCustomerName}}</label>
            </td>
          </tr>
          <tr>
            <td>
              <strong>Division:</strong>
            </td>
            <td>
              <label>{{divisionName}}</label>
            </td>
            <td>
              <strong>Ship To:</strong>
            </td>
            <td>
              <label>{{shipToName}}</label>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <strong>Breakdown Location:</strong>
            </td>
            <td colspan="2">
              <label>{{woRoViewDetails.BreakdownAddress}}</label>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-sm-4">
      <div class="col-sm-12">
        <div class="col-md-12 view-detail-label">
          <strong>Initial Complaint</strong>
        </div>
        <div class="col-md-12 statusDivs text-center">
          <label>{{woRoViewDetails.breakdownReport}}</label>
        </div>
        <div class="col-md-6">
          <button class=" btn btn-semi-round bgBlue m-1 w-100 text-center" (click)="viewNotes();">
            View Full Notes
          </button>
        </div>
        <div class="col-md-6">
          <button class="btn btn-semi-round bgBlue m-1 w-100 text-center" (click)="viewAttachment();">
            View Attachments
          </button>
        </div>
      </div>
      <div class="col-sm-12 mt-1">
        <div class="col-md-12 view-detail-label">
          <strong>Metrics</strong>
        </div>
        <table class="table col-12">
          <tbody>
            <tr>
              <td>
                <strong>Call Entered:</strong>
              </td>
              <td>
                <label>{{woRoViewDetails.TSQdDateSubmitted | timezoneConvertDate}}</label>
              </td>
            </tr>
            <tr>
              <td>
                <strong>ETA:</strong>
              </td>
              <td>
                <label>
                  {{woRoViewDetails.TSTdETA | timezoneConvertDate}}
                  <i>({{woRoViewDetails.ETAMinutes}})</i>
                </label>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Onsite ATA:</strong>
              </td>
              <td>
                <label>
                  {{woRoViewDetails.WO_FirstROATA | timezoneConvertDate}}
                  <i>({{woRoViewDetails.OnsiteATAMinutes}})</i>
                </label>
              </td>
            </tr>
            <tr>
              <td>
                <strong>ATC:</strong>
              </td>
              <td>
                <label>{{woRoViewDetails.WO_FirstROATC | timezoneConvertDate}}</label>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Roll Time:</strong>
              </td>
              <td> </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="roDiv woDetailDiv" id="accordion">
    <nb-card *ngFor="let roDetails of woRODetails; let i = index" [attr.id]="i" class="roAccordion mt-2">
      <nb-card-header data-toggle="collapse" [attr.data-target]="'#ro_'+ roDetails.RONumber" class="card-header cursor">
        <strong>Repair Order: #{{roDetails.RONumber}}</strong>
      </nb-card-header>
      <nb-card-body id="{{'ro_'+roDetails.RONumber}}" class="collapse" [ngClass]="{'show': i === 0}">
        <div class="col-sm-3 mt-2">
          <mat-form-field>
            <input class="bord-none" type="text" value="{{roDetails.ROService}}" matInput placeholder="Service"
              disabled>
          </mat-form-field>
        </div>
        <div class="col-sm-3 mt-2">
          <mat-form-field>
            <input class="bord-none" type="text" [value]="roDetails.SubService" matInput placeholder="Sub Service"
              disabled>
          </mat-form-field>
        </div>
        <div class="col-sm-3 mt-2">
          <mat-form-field>
            <input class="bord-none" type="text" [value]="roDetails.ROStatus" matInput placeholder="RO Status" disabled>
          </mat-form-field>
        </div>
        <div class="col-sm-3 mt-2">
          <mat-form-field>
            <input class="bord-none" type="text" value="${{roDetails.ROPInvoicedAmount}} {{roDetails.SRT}}" matInput
              placeholder="Est Price / SRT" disabled>
          </mat-form-field>
        </div>
        <div class="col-sm-6 mt-2">
          <mat-form-field>
            <input class="bord-none" type="text"
              [value]="roDetails.WorkCode + roDetails.SystemCode + roDetails.AssemblyCode" matInput placeholder="VRMS"
              disabled>
          </mat-form-field>
        </div>
        <div class="col-sm-6 mt-2">
          <mat-form-field>
            <input class="bord-none" type="text" [value]="roDetails.ROWorkCompleted" matInput
              placeholder="Work Completed" disabled>
          </mat-form-field>
        </div>
        <div class="col-sm-6 mt-2">
          <mat-form-field>
            <textarea type="text" [value]="roDetails.ROWorkRequested" matInput placeholder="Work Requested"
              disabled></textarea>
          </mat-form-field>
        </div>
        <div class="col-sm-6 mt-2">
          <mat-form-field>
            <textarea type="text" [value]="roDetails.ROPSpecificNote" matInput placeholder="RO Note"
              disabled></textarea>
          </mat-form-field>
        </div>
      </nb-card-body>
    </nb-card>
  </div>

</mat-dialog-content>